import { ChangePasswordMessages, TranslationChangePasswordMessages } from "@languages/interfaces";

export const messages: TranslationChangePasswordMessages = {
  [ChangePasswordMessages.currentPasswordInstruction]: "Insira sua senha Topcon Customer atual",
  [ChangePasswordMessages.currentPasswordLabel]: "Senha atual",
  [ChangePasswordMessages.newPasswordInstruction]: "Insira sua nova senha",
  [ChangePasswordMessages.newPasswordLabel]: "Nova senha",
  [ChangePasswordMessages.confirmPasswordInstruction]: "Confirme sua nova senha",
  [ChangePasswordMessages.currentPasswordRequired]: "Senha atual é obrigatória",
  [ChangePasswordMessages.newPasswordRequired]: "Nova senha é obrigatória",
  [ChangePasswordMessages.confirmPasswordRequired]: "Confirmação de senha é obrigatória",
  [ChangePasswordMessages.newPasswordMinimumLength]: "Nova senha deve ter no mínimo 6 caracteres",
  [ChangePasswordMessages.confirmPasswordNotMatch]: "As senhas não conferem",
  [ChangePasswordMessages.changePasswordSuccess]: "Senha alterada com sucesso",
  [ChangePasswordMessages.changePasswordFailed]: "Falha ao alterar senha",
  [ChangePasswordMessages.changePasswordButtonTitle]: "Alterar senha"
};